<template>
  <div class="normal-layout-box show-flex-box-c">
      <div class="view-box">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
    isShowLoginWin: false,
    }
  },
  components: {
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
  .normal-layout-box {
    width: 100%;
    height: 100%;
    & .view-box> {
        width: 100%;
        height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/appLayout.vue